import { createSelector } from 'reselect';
import { OrderState } from '../types';

const getRootOrderState = (state: { newOrder: OrderState }) => state.newOrder;

export const getTravellers = createSelector(getRootOrderState, order => order.travellers);
